import script from "./BankCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BankCard.vue?vue&type=script&setup=true&lang=js"

import "./BankCard.vue?vue&type=style&index=0&id=bff54a56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bff54a56"]])

export default __exports__